import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var RestoreIcon = function RestoreIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "RestoreIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8.381 1.236a.82.82 0 0 1 .01 1.165l-.58.586q.28-.007.574 0c.58.013 1.229.084 1.867.345a6 6 0 0 1 2.84 2.41 6.1 6.1 0 0 1-.492 7.09 6 6 0 0 1-3.145 1.987 5.95 5.95 0 0 1-3.707-.262 6 6 0 0 1-2.84-2.409 6.1 6.1 0 0 1-.893-3.625.826.826 0 0 1 .882-.765c.456.031.8.425.769.878-.065.932.164 1.86.653 2.65a4.36 4.36 0 0 0 2.058 1.748 4.3 4.3 0 0 0 2.671.189 4.34 4.34 0 0 0 2.276-1.44 4.458 4.458 0 0 0 .357-5.18 4.36 4.36 0 0 0-2.058-1.747c-.374-.153-.795-.211-1.278-.223q-.284-.006-.581.003l.627.634a.82.82 0 0 1-.01 1.165.83.83 0 0 1-1.17-.01L5.22 4.413a.82.82 0 0 1 0-1.155l1.99-2.012a.83.83 0 0 1 1.17-.01",
      clipRule: "evenodd"
    })
  }));
};

export { RestoreIcon };
